import { AxiosResponse } from 'axios';
import { appAxios } from '@doda/common/src/libs/axios/appAxios';
import { ScoutServiceJobs } from '@doda/common/src/interfaces/api/scoutServiceJobs';

/**
 * 気になるスカウトサービス求人取得
 * @param {number} pageNumber
 * @param {ScoutServiceJobFilterType} filterId 条件で絞り込み
 * @param {ScoutServiceJobSortType} sortId 条件で並び替え
 * @return {ScoutServiceJobs[]} 気になるスカウトサービス求人取得型定義
 */
export const getBookmarkList = async ({ pageNumber, filterId, sortId }) => {
  return appAxios({
    url: '/dcfront/bookmark/bookmarkListTabAjax/',
    params: {
      page: pageNumber,
      filter_id: filterId,
      sort_id: sortId,
    },
  }).then((res: AxiosResponse<ScoutServiceJobs>) => {
    return res.data;
  });
};
